var storefrontApp = angular.module('storefrontApp');

storefrontApp.filter('imgurl', function () {
    return function (input, type) {
        if (!type) {
            return input;
        }

        var extention = '.' + input.split('.').pop();
        var suffix = "_" + type;
        var result = input.replace(extention, suffix+extention);
        return result;
    };
});

storefrontApp.filter('free_or_value', function () {
    return function (input, free) {
        if (angular.isUndefined(input)) {
            return input;
        }
        if (input.amount == 0) {
            return free;
        }
        return input.formattedAmount;
    };
});

storefrontApp.filter('now', function () {
    return function (days) {
        var date = new Date();
        date.setDate(date.getDate() + days);
        return date;
    };
});

storefrontApp.filter('range_mim_max', function () {
    return function (mim, max, start_text ) {
        if (angular.isDefined(mim) || angular.isDefined(max))
        {
            if (mim == 0) {
                return start_text + ' ' + max.toString();
            }
            
            return mim.toString() + ' - ' + max.toString();
        }
        return '';
    };
});

storefrontApp.filter('text_format', [function () {
    return function (input) {
        if (arguments.length > 1) {
            // If we have more than one argument (insertion values have been given)
            var str = input;
            // Loop through the values we have been given to insert
            for (var i = 1; i < arguments.length; i++) {
                // Compile a new Regular expression looking for {0}, {1} etc in the input string
                var reg = new RegExp("\\{" + (i - 1) + "\\}");
                // Perform the replace with the compiled RegEx and the value
                str = str.replace(reg, arguments[i]);
            }
            return str;
        }

        return input;
    };
}]);
